import Vue from 'vue'
import App from '@/App'
import firestore from '@/plugins/firestore'
import VueSwal from 'vue-sweetalert2'
import store from '@/store'
import router from '@/plugins/router'

Vue.use(VueSwal)
Vue.config.productionTip = false
Vue.prototype.$version = '2.2.3'

/**
 * Vue, firestoreを呼び出すメイン関数
 */
async function main () {
  await firestore.init()
  const app = new Vue({
    el: '#app',
    store,
    router,
    components: { App },
    template: '<App/>'
  })
  app.$mount('#app')
}

main()



// WEBPACK FOOTER //
// ./src/main.js